import { Link } from 'react-router-dom';
import type { LucideIcon } from 'lucide-react';

interface ConceptCardProps {
  term: string;
  definition: string;
  icon?: LucideIcon;
  href?: string;
  color?: 'green' | 'blue' | 'amber' | 'coral' | 'gray';
  tag?: string;
}

const colorMap = {
  green: { bg: 'bg-primary-50', border: 'border-primary-200', icon: 'text-primary-600', tag: 'bg-primary-100 text-primary-700' },
  blue: { bg: 'bg-[var(--slate-dim)]', border: 'border-[var(--slate)]', icon: 'text-[var(--text-ter)]', tag: 'bg-[var(--slate-dim)] text-[var(--text-sec)]' },
  amber: { bg: 'bg-electric-mustard-50', border: 'border-electric-mustard-200', icon: 'text-electric-mustard-700', tag: 'bg-electric-mustard-100 text-electric-mustard-800' },
  coral: { bg: 'bg-luminous-coral-50', border: 'border-luminous-coral-200', icon: 'text-luminous-coral-700', tag: 'bg-luminous-coral-100 text-luminous-coral-800' },
  gray: { bg: 'bg-[var(--surface)]', border: 'border-[var(--rule)]', icon: 'text-[var(--text-ter)]', tag: 'bg-[var(--hover-tint)] text-[var(--text-sec)]' },
};

export function ConceptCard({ term, definition, icon: Icon, href, color = 'gray', tag }: ConceptCardProps) {
  const c = colorMap[color];
  const inner = (
    <div className={` border p-4 ${c.bg} ${c.border} ${href ? 'hover:shadow-sm transition-shadow' : ''}`}>
      <div className="flex items-start gap-3">
        {Icon && (
          <div className={`w-8 h-8  flex items-center justify-center flex-shrink-0 bg-[var(--bg-raised)] border ${c.border}`}>
            <Icon className={`h-4 w-4 ${c.icon}`} />
          </div>
        )}
        <div className="min-w-0">
          <div className="flex items-center gap-2 flex-wrap">
            <span className="text-sm font-semibold text-[var(--text-pri)] font-heading">{term}</span>
            {tag && <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${c.tag}`}>{tag}</span>}
          </div>
          <p className="text-sm text-[var(--text-sec)] mt-1 leading-relaxed">{definition}</p>
        </div>
      </div>
    </div>
  );

  if (href) return <Link to={href}>{inner}</Link>;
  return inner;
}
